import * as React from "react"
import * as classNames from "./RhCtxAgencyHeroSection.module.scss"
import CtxHeroSection from "../../common/sections/ctx-hero-section/CtxHeroSection"
import Card from "../../common/blocks/card/Card"
import Button from "../../common/blocks/button/Button"

const RhCtxAgencyHeroSection = ({
  agenceName,
  imageSrc,
  imageAlt,
  metrics,
  searchTerm
}) => {
  return (
    <CtxHeroSection
      imgSrc={imageSrc}
      imgAlt={imageAlt}
    >
      <div className="container">
        <Card className="card_bottom card_small card_left flex flex-direction-column p-6 gap-4 fade-in-bottom">
          <h1>{agenceName}</h1>
          <div className={`${classNames.agenceData} ${"quartary-text-color"}`}>
            <div>
              {metrics?.map((metric, index) => (
                <span key={index}>
                  <strong>{metric?.number}</strong>&nbsp;
                  {metric?.text}&nbsp;
                  {index < metrics.length - 1 && "|"}{" "}
                </span>
              ))}
            </div>
          </div>
          <Button
            aspect="classique"
            size="large"
            to={encodeURI("/annonces/?q="+searchTerm)}
            color="primary"
            className={classNames.agencyJobsAdLink}
          >
            Voir les offres de l’agence
          </Button>
        </Card>
      </div>
    </CtxHeroSection>
  )
}

export const name = "RhCtxAgencyHero"

export const init = (componentData, pageContext) => {
  // console.log(JSON.stringify(pageContext.itemData, undefined, 2))
  return (
    <RhCtxAgencyHeroSection
      key={componentData.id}
      agenceName={pageContext.itemData?.attributes?.name}
      imageSrc={pageContext.itemData?.attributes?.imageHero?.data?.attributes?.url}
      imageAlt={pageContext.itemData?.attributes?.imageHero?.data?.attributes?.alt}
      metrics={pageContext.itemData?.attributes?.metrics}
      searchTerm={pageContext.itemData?.attributes?.city}
    />
  )
}

export default RhCtxAgencyHeroSection
